import { render, staticRenderFns } from "./GasDevicePrice.vue?vue&type=template&id=ca3b90f0&scoped=true&"
import script from "./GasDevicePrice.vue?vue&type=script&lang=js&"
export * from "./GasDevicePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3b90f0",
  null
  
)

export default component.exports